import { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";
import DataTable from "react-data-table-component";
import { ThreeDot } from "../../../assets/images";

export default function EscapeTipsRedeemCommission() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    duration: "",
    redeemtionValue: "",
    id: "",
  });
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [allCommisions, setAllCommisions] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const getAllCommisions = () => {
    setLoading(true);
    axios
      .get(
        `/escape-bucks/escape-tips-redeem-commission-list?page=${page}&limit=${limit}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setAllCommisions(res.data.data);
          setPagination(res.data.pagination);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const addNewRedeemCommision = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        "/escape-bucks/add-escape-tips-redeem-commission",
        formData,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          setFormData({
            productId: "",
            duration: "",
            redeemtionValue: "",
          });
          getAllCommisions();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    getAllCommisions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const columns = [
    {
      name: "Duration (Months)",
      selector: (row) => row?.duration,
    },
    {
      name: "Redemption Value",
      selector: (row) => `${row?.redeemtionValue}%`,
    },

    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                const { productId, duration, redeemtionValue, _id } = row;
                setFormData({
                  productId: productId,
                  duration,
                  redeemtionValue,
                  id: _id,
                });
                setShowEditModal(true);
              }}
            >
              Edit
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  const updateRedeemCommision = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(
        "/escape-bucks/update-escape-tips-redeem-commission",
        formData,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          handleClose();
          getAllCommisions();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleClose = () => {
    setShowEditModal(false);
    setFormData({
      productId: "",
      duration: "",
      redeemtionValue: "",
    });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <Modal show={showEditModal} centered>
        <Modal.Header>
          <Modal.Title>Update Redeem Commision</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={updateRedeemCommision}>
            <Form.Group className="mb-3">
              <Form.Label>Select Redemption Duration</Form.Label>
              <Form.Control
                as="select"
                name="duration"
                value={formData.duration}
                onChange={handleOnChange}
                required
              >
                <option value="">Select Duration</option>

                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                  <option value={item} key={item}>
                    {item} Months
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Commision Value</Form.Label>
              <Form.Label>Redemption Percentage Value (%)</Form.Label>
              <Form.Control
                type="number"
                min={0}
                placeholder="Redemption Percentage Value"
                required
                name="redeemtionValue"
                value={formData.redeemtionValue}
                onChange={handleOnChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="mx-3" type="submit" variant="primary">
                Update
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <div className="cert_det_inner">
              <h2>Add Escape Trips Redeem Commision</h2>
            </div>
            <Form onSubmit={addNewRedeemCommision}>
              <Row>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Select Redemption Duration</Form.Label>
                    <Form.Control
                      as="select"
                      name="duration"
                      value={formData.duration}
                      onChange={handleOnChange}
                      required
                    >
                      <option value="">Select Duration</option>

                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                        <option value={item} key={item}>
                          {item} Months
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Redemption Percentage Value (%)</Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      placeholder="Redemption Percentage Value"
                      required
                      name="redeemtionValue"
                      value={formData.redeemtionValue}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="sub_but mt-3">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
            <div className="cert_det_inner">
              <h2>Escape Tips Redeem Commission Lists</h2>

              <DataTable
                columns={columns}
                data={allCommisions}
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
                pagination
                paginationDefaultPage={page}
                paginationServer
                paginationTotalRows={pagination.totalRows}
                paginationPerPage={limit}
                paginationRowsPerPageOptions={[10, 15, 20, 40]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={changePage}
              />
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};
